// @flow

import React from 'react';
import styled from 'styled-components';
import DividerLineCSSBottom from './shared-styles/DividerLineCSSBottom';
import { CSS_BREAKPOINTS_MIN, SPACING_BASE } from '../config/constants';

const HeadStyle = styled.div`
  ${DividerLineCSSBottom}
  margin: 0 0 ${SPACING_BASE * 2}px;
  padding: ${SPACING_BASE}px 0 ${SPACING_BASE * 2}px;
  text-align: center;
  
  @media ${CSS_BREAKPOINTS_MIN.sm} {
    margin: 0 0 ${SPACING_BASE * 6}px;
    padding: ${SPACING_BASE}px 0 ${SPACING_BASE * 4}px;
  }
`;

const CardHead = (props: any) => {
  const { children, ...rest } = props;

  return (
    <HeadStyle {...rest}>
      {children}
    </HeadStyle>
  );
};

export default CardHead;
